import { useCallback } from 'react';
import type { ComponentProps } from 'react';

import type { ADFRenderer } from '@confluence/adf-renderer';
import { useProgressiveRenderingConfig } from '@confluence/complex-page/entry-points/useProgressiveRenderingConfig';
import { fg } from '@confluence/feature-gating';

import { ProgressiveReactSerializer } from './ProgressiveReactSerializer';

export const useCreateSerializer = (props: Parameters<typeof useProgressiveRenderingConfig>[0]) => {
	const { skip } = props;

	const { isComplexPage, batchSize } = useProgressiveRenderingConfig(props);

	/**
	 * Creates a new `Serializer` that progressively renders ADF as described at https://hello.atlassian.net/wiki/spaces/~lmarinov/pages/5177285037/COMPLEXIT+Progressive+rendering+of+ADF.
	 */
	const createSerializer: ComponentProps<typeof ADFRenderer>['createSerializer'] = useCallback(
		(init) => new ProgressiveReactSerializer(init, batchSize),
		[batchSize],
	);

	return !skip && isComplexPage && fg('cc_complexit_fe_progressive_adf_rendering')
		? createSerializer
		: undefined;
};
